module.exports = __webpack_public_path__ + "img/lev4.596e34b0.png";